import AdditionalCommentsComponent from "../components/organisms/AdditionalComments";
import './section.scss';

const AdditionalCommments = ()=> {
return (
  <div className="survey-wrapper">
      <div role="form" id="Encuesta" aria-label="Encuesta" className="survey-container">
          {/* <ProgressPoints/> */}
          <div className="survey pt-5">
              
              <div className="image-wrapper text-center my-8 ">
                  {/* <img src={ section1 } alt="section-1" className="mx-auto"></img> */}
              </div>

              <div className="fields-wrapper">
              <AdditionalCommentsComponent />
              </div>
          </div>
      </div>
  </div>
)
}

export default AdditionalCommments
